// @flow
import { call, put, takeLatest } from 'redux-saga/effects';
import getSecondOpinionContent from 'api/content/getSecondOpinionContent';
import { requestContent, receiveContent } from './secondOpinionActions';
import { type ActionType } from 'redux-actions';
import { addItemTask } from 'ducks/coreDataSaga';

export function* requestSecondOpinionContent(
  action: ActionType<typeof requestContent>
): Generator<*, *, *> {
  const { token, observationsMap } = action.payload;
  try {
    const data: ContentBlob = yield call(getSecondOpinionContent, token);
    const ugc_id = yield call(addItemTask, {
      data,
      observationsMap,
      clientId: 1,
    });

    yield put.resolve(receiveContent({ ugc_id }));
  } catch (error) {
    yield put(receiveContent(error));
  }
}

export default function* secondOpinionSaga(): Generator<*, *, *> {
  yield takeLatest(requestContent, requestSecondOpinionContent);
}



// WEBPACK FOOTER //
// ./src/pages/moderation/second-opinion/secondOpinionSaga.js